export default __webpack_public_path__ + "static/media/image (3).9803ac68.png";